export const ROUTE_PATH = '/gift-set-arrangement';

export const PATCH_URL = '/gift-set/';
